export default "__VITE_ASSET__ClExnKlw__"